import { CREATE_PROPERTY_EVENT_FAILURE, CREATE_PROPERTY_EVENT_REQUEST, CREATE_PROPERTY_EVENT_SUCCESS, GET_PROPERTY_EVENTS_FAILURE, GET_PROPERTY_EVENTS_REQUEST, GET_PROPERTY_EVENTS_SUCCESS } from "../constants/key-pickup-drop-events.constants";


const initialState = {
    loading: false,
    data: [],
    error: "",
    count: 0,
    createdEvent: {
        loading: false,
        data: [],
        error: "",
    },
};

export const propertyEventReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case GET_PROPERTY_EVENTS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case GET_PROPERTY_EVENTS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: "",
            };
        case GET_PROPERTY_EVENTS_FAILURE:
            return {
                ...state,
                loading: false,
                data: [],
                error: action.payload,
            };

        case CREATE_PROPERTY_EVENT_REQUEST:
            return {
                ...state,
                createdEvent: {
                    ...state.createdEvent,
                    loading: true,
                    error: "",
                    data: [],
                },
            };
        case CREATE_PROPERTY_EVENT_SUCCESS:
            return {
                ...state,
                createdEvent: {
                    ...state.createdEvent,
                    loading: false,
                    data: action.payload,
                },
            };
        case CREATE_PROPERTY_EVENT_FAILURE:
            return {
                ...state,
                createdEvent: {
                    ...state.createdEvent,
                    loading: false,
                    data: [],
                    error: action.payload,
                },
            };

        default:
            return state;
    }
};
